import React from 'react'

import Field from '../../../../../../../components/Form/Field'
import Step from '../../../../../../../features/components/Forms/StepForm/Step'

import { CLICK_THROUGH_LINK } from '../../../../fields'

const stepFields = [CLICK_THROUGH_LINK]

function ClickThroughLinkStep({ formik, handleStepChange }) {
  const handleContinue = () => {
    handleStepChange(stepFields)
  }

  return (
    <Step formTitle="Create an ad" stepTitle="Please provide a click through link" handleContinue={handleContinue}>
      <Field formik={formik} name={CLICK_THROUGH_LINK} placeholder="Click Through Link" autoComplete="off" />
    </Step>
  )
}

export default ClickThroughLinkStep
